import * as ko from 'knockout';

import {BaseCheckItem} from "../BaseCheckItem";
import {ICheckItemParams} from "../ICheckItemParams";

import Template from 'Core/Components/ActionCheckList/CheckItems/YesNo/Templates/Template.html';

ko.templates['Core/Components/ActionCheckList/CheckItems/YesNo/Templates/Template'] = Template;

export class YesNoCheckItem extends BaseCheckItem {
    constructor(params: ICheckItemParams) {
        super(params);
    }

    GetTemplateName(): string {
        return 'Core/Components/ActionCheckList/CheckItems/YesNo/Templates/Template';
    }

    protected SetValue(value: any) {
        this.Value(value === '1');
    }
}